import {arrayToMap, arrayToSet, filterMapByKey, filterMapByKeys} from '../../atUtils'

export default function({
    actionTypes: {
        NEW_COMMENTS_ADD,
        OLD_COMMENTS_ADD,
        COMMENTS_INFO_CLEAR,
        CHANGE_COMMENTS_ORDER,
        COMMENTS_LOADED_SET,
        COMMENTS_LOADING_SET,
        SENDING_COMMENT_SET,
        RECENTLY_ADDED_COMMENTS_ADD,
        RECENTLY_ADDED_COMMENTS_REMOVE,
        COMMENTS_SCROLL_TO_SET,
        COMMENT_REMOVE,
        EDITING_COMMENT_ID_SET,
        EDITING_COMMENT_TEXT_SET,
        UPDATE_COMMENT,
        UPDATING_COMMENT_ID_SET,
        SHOW_NEW_COMMENT_INPUT_SET,
        NEW_COMMENT_SET,
        NEW_COMMENT_REMOVE,
    },
    initAppData = {}
}) {

    const newCommentsTexts = initAppData.newCommentsTexts ? initAppData.newCommentsTexts : {}
    const isNewCommentsOnTop = !!initAppData.COMMENTS.IS_NEW_COMMENTS_ON_TOP

    return {
        initialState: {
            users: {},
            comments: [],
            commentsCount: 0,
            allCommentsUserIds: [],
            isNewCommentsOnTop,
            commentsLoaded: false,
            loading: false,
            recentlyAddedCommentsIds: {},
            commentsScrollTo: null,
            editingCommentId: null,
            editingCommentText: '',
            sendingComment: false,
            updatingCommentId: null,
            showNewCommentInput: false,
            newCommentsTexts,
        },
        handlers: {
            [NEW_COMMENTS_ADD]: (state, {payload: {comments, users, commentsCount, allCommentsUserIds}}) => ({
                ...state,
                comments: [...comments, ...state.comments],
                users: {...state.users, ...arrayToMap(users)},
                commentsCount,
                allCommentsUserIds,
            }),
            [OLD_COMMENTS_ADD]: (state, {payload: {comments, users, commentsCount, allCommentsUserIds}}) => ({
                ...state,
                comments: [...state.comments, ...comments],
                users: {...state.users, ...arrayToMap(users)},
                commentsCount,
                allCommentsUserIds,
            }),
            [UPDATE_COMMENT]: (state, {payload: comment}) => {
                return {
                    ...state,
                    comments: state.comments.map(c => c.id === comment.id ? comment : c)
                }
            },
            [COMMENTS_INFO_CLEAR]: (state) => ({
                ...state,
                comments: [],
                users: {},
                commentsCount: 0,
                allCommentsUserIds: [],
                commentsLoaded: false
            }),
            [COMMENT_REMOVE]: (state, {payload: commentId}) => ({
                ...state,
                comments: state.comments.filter(c => c.id !== commentId),
            }),
            [EDITING_COMMENT_ID_SET]: (state, {payload: editingCommentId}) => ({
                ...state,
                editingCommentId,
            }),
            [EDITING_COMMENT_TEXT_SET]: (state, {payload: editingCommentText}) => ({
                ...state,
                editingCommentText,
            }),
            [CHANGE_COMMENTS_ORDER]: (state, {payload: isNewCommentsOnTop}) => ({
                ...state,
                isNewCommentsOnTop
            }),
            [COMMENTS_LOADED_SET]: (state, {payload: commentsLoaded}) => ({
                ...state,
                commentsLoaded
            }),
            [COMMENTS_LOADING_SET]: (state, {payload: loading}) => ({
                ...state,
                loading
            }),
            [SENDING_COMMENT_SET]: (state, {payload: sendingComment}) => ({
                ...state,
                sendingComment
            }),
            [RECENTLY_ADDED_COMMENTS_ADD]: (state, {payload: recentlyAddedComments}) => ({
                ...state,
                recentlyAddedCommentsIds: {
                    ...state.recentlyAddedCommentsIds,
                    ...arrayToSet(recentlyAddedComments.map(c => c.id))
                }
            }),
            [RECENTLY_ADDED_COMMENTS_REMOVE]: (state, {payload: recentlyAddedComments}) => ({
                ...state,
                recentlyAddedCommentsIds: filterMapByKeys(state.recentlyAddedCommentsIds, recentlyAddedComments.map(c => c.id))
            }),
            [COMMENTS_SCROLL_TO_SET]: (state, {payload: commentsScrollTo}) => ({
                ...state,
                commentsScrollTo
            }),
            [UPDATING_COMMENT_ID_SET]: (state, {payload: updatingCommentId}) => ({
                ...state,
                updatingCommentId,
            }),
            [SHOW_NEW_COMMENT_INPUT_SET]: (state, {payload: showNewCommentInput}) => ({
                ...state,
                showNewCommentInput,
            }),
            [NEW_COMMENT_SET]: (state, {payload: {entityId, text}}) => ({
                ...state,
                newCommentsTexts: {
                    ...state.newCommentsTexts,
                    [entityId]: text
                },
            }),
            [NEW_COMMENT_REMOVE]: (state, {payload: entityId}) => ({
                ...state,
                newCommentsTexts: filterMapByKey(state.newCommentsTexts, entityId)
            }),
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/reducerGenerator.js